/* Dear Nikola collection pages (loaded on collection templates only).
   Filters, sort and Load more fetch this page's own section (?section_id=) and swap the pieces, so the grid never reloads and every state is a real address.
   Without this script the links and the Load more link still work as plain page loads. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }
  var body = document.body;
  var root = $('[data-dnc-list]');

  /* ---------- quick add (same drawer path as the rest of the site) ---------- */
  function addOne(variantId, btn) {
    var cd = document.querySelector('cart-drawer');
    var data = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (cd && typeof cd.getSectionsToRender === 'function') {
      data.sections = cd.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      data.sections_url = window.location.pathname;
    }
    if (btn) btn.classList.add('is-busy');
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || 'add failed');
        if (cd && typeof cd.renderContents === 'function') {
          cd.classList.remove('is-empty');
          cd.renderContents(res.j, false);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (e) {
        if (btn) { btn.setAttribute('data-error', '1'); setTimeout(function () { btn.removeAttribute('data-error'); }, 2500); }
        if (window.console) console.warn('[dn-coll] add failed', e);
      })
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dnc-add]');
    if (!b) return;
    e.preventDefault();
    addOne(b.getAttribute('data-dnc-add'), b);
  });

  /* ---------- charm carousel: arrows scroll, the track also swipes ---------- */
  $$('[data-dnc-ch]').forEach(function (wrap) {
    var track = $('[data-dnc-ch-track]', wrap), prev = $('[data-dnc-ch-prev]', wrap), next = $('[data-dnc-ch-next]', wrap);
    if (!track || !prev || !next) return;
    function state() {
      prev.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
      next.setAttribute('aria-disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2 ? 'true' : 'false');
    }
    function go(dir) {
      var c = track.querySelector('.dnc-card'), w = c ? c.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: dir * Math.max(w, track.clientWidth - w), behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { if (prev.getAttribute('aria-disabled') !== 'true') go(-1); });
    next.addEventListener('click', function () { if (next.getAttribute('aria-disabled') !== 'true') go(1); });
    track.addEventListener('scroll', state, { passive: true });
    window.addEventListener('resize', state);
    state();
  });

  /* ---------- smooth FAQ accordion ---------- */
  $$('.dnc-faq details').forEach(function (d) {
    var s = $('summary', d), a = $('.ans', d);
    if (!s || !a) return;
    s.addEventListener('click', function (e) {
      if (reduce || !a.animate) return;
      e.preventDefault();
      var ease = 'cubic-bezier(.16,1,.3,1)';
      if (d.open) {
        d.classList.add('closing');
        var h = a.offsetHeight;
        var an = a.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: ease });
        an.onfinish = function () { d.open = false; d.classList.remove('closing'); };
      } else {
        d.open = true;
        var h2 = a.offsetHeight;
        a.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 340, easing: ease });
      }
    });
  });

  if (!root) return;

  /* ---------- the sticky row sits under the header when the header is showing ---------- */
  var header = document.querySelector('.shopify-section-group-header-group.section-header') || document.querySelector('.section-header') || document.getElementById('shopify-section-header');
  function setTop() {
    var t = 0;
    if (header && header.classList.contains('shopify-section-header-sticky') && !header.classList.contains('shopify-section-header-hidden')) {
      t = header.offsetHeight;
    }
    root.style.setProperty('--dnc-top', t + 'px');
  }
  if (header && window.MutationObserver) {
    new MutationObserver(setTop).observe(header, { attributes: true, attributeFilter: ['class'] });
  }
  window.addEventListener('resize', setTop);
  setTop();
  var barEl = $('[data-dnc-bar]', root);
  if (barEl) barEl.style.top = 'var(--dnc-top, 0px)';

  /* ---------- state helpers ---------- */
  var pop = null;           /* the open filter panel, if any */
  var drawer = $('[data-dnc-drawer]', root);
  var opener = null;
  function isPhone() { return window.matchMedia && window.matchMedia('(max-width:900px)').matches; }
  function numOrBlank(v) {
    v = String(v == null ? '' : v).replace(/[^0-9.]/g, '');
    if (v === '') return '';
    var n = parseFloat(v);
    return isNaN(n) ? '' : String(Math.max(0, Math.round(n)));
  }
  function currentSort() {
    var p = new URLSearchParams(window.location.search);
    return p.get('sort_by');
  }
  /* the filter choices in a group of inputs, as a query string (plus the chosen sort) */
  function queryFrom(scope) {
    var p = carryView(new URLSearchParams());
    var sort = currentSort();
    if (sort) p.set('sort_by', sort);
    $$('input[data-dnc-in]:checked', scope).forEach(function (i) { p.append(i.name, i.value); });
    var lo = '', hi = '', loName = '', hiName = '';
    $$('[data-dnc-price]', scope).forEach(function (i) {
      var v = numOrBlank(i.value);
      if (i.getAttribute('data-dnc-price') === 'min') { lo = v; loName = i.name; } else { hi = v; hiName = i.name; }
    });
    if (lo !== '' && hi !== '' && Number(lo) > Number(hi)) { var t = lo; lo = hi; hi = t; }
    if (lo !== '' && Number(lo) > 0) p.set(loName, lo);
    if (hi !== '') p.set(hiName, hi);
    return p.toString();
  }
  /* an alternate layout is picked with ?view=, so every request must keep it or the section would not be found */
  function carryView(p) {
    var v = new URLSearchParams(window.location.search).get('view');
    if (v && !p.get('view')) p.set('view', v);
    return p;
  }
  function filtersOnly(search) {
    var p = new URLSearchParams(search);
    p.delete('page'); p.delete('section_id');
    return carryView(p);
  }

  /* ---------- fetch and swap ---------- */
  var seq = 0;
  function nodeFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-dnc-list]');
  }
  function fetchSection(qs) {
    var id = root.getAttribute('data-section');
    var url = window.location.pathname + '?' + (qs ? qs + '&' : '') + 'section_id=' + encodeURIComponent(id);
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var n = nodeFromHtml(html);
      if (!n) throw new Error('section missing');
      return n;
    });
  }
  function scrollToGrid() {
    var bar = $('[data-dnc-bar]', root);
    if (!bar) return;
    var top = parseFloat(getComputedStyle(root).getPropertyValue('--dnc-top')) || 0;
    if (bar.getBoundingClientRect().top > top + 1) return;
    var meta = $('[data-dnc-swap="meta"]', root), grid = $('[data-dnc-grid]', root);
    var el = meta && getComputedStyle(meta).display !== 'none' ? meta : grid;
    var y = window.pageYOffset + el.getBoundingClientRect().top - bar.offsetHeight - top;
    window.scrollTo({ top: Math.max(0, y - 2), behavior: reduce ? 'auto' : 'smooth' });
  }
  function swapIn(nr) {
    /* the row: counts, filter button, sort label and menu, then the pills (their panels are closed by now) */
    $$('[data-dnc-cnt]', root).forEach(function (el) {
      var n = $('[data-dnc-cnt]', nr);
      if (n) el.textContent = n.textContent;
    });
    var fb = $('[data-dnc-drawer-open]', root), nfb = $('[data-dnc-drawer-open]', nr);
    if (fb && nfb) { fb.className = nfb.className; $('.n', fb).textContent = $('.n', nfb).textContent; }
    var sv = $('[data-dnc-sortval]', root), nsv = $('[data-dnc-sortval]', nr);
    if (sv && nsv) sv.textContent = nsv.textContent;
    var sp = $('[data-dnc-sortpop]', root), nsp = $('[data-dnc-sortpop]', nr);
    if (sp && nsp) sp.innerHTML = nsp.innerHTML;
    var pills = $('.dnc-pills', root), npills = $('.dnc-pills', nr);
    if (pills && npills) pills.innerHTML = npills.innerHTML;
    var meta = $('[data-dnc-swap="meta"]', root), nmeta = $('[data-dnc-swap="meta"]', nr);
    if (meta && nmeta) meta.replaceWith(nmeta);
    var bodyEl = $('[data-dnc-swap="body"]', root), nbody = $('[data-dnc-swap="body"]', nr);
    if (bodyEl && nbody) {
      bodyEl.replaceWith(nbody);
      $$('[data-dnc-grid] > .dnc-card', nbody).forEach(function (c, i) {
        if (reduce) return;
        c.classList.add('dnc-fade');
        c.style.animationDelay = (Math.min(i, 8) * 40) + 'ms';
        c.addEventListener('animationend', function () { c.classList.remove('dnc-fade'); c.style.animationDelay = ''; }, { once: true });
      });
    }
    /* the phone sheet stays open, so keep its place and the box the person just used */
    var dr = $('[data-dnc-drawer]', root), ndr = $('[data-dnc-drawer]', nr);
    if (dr && ndr) {
      var keep = document.activeElement, kn = '', kv = '';
      if (keep && dr.contains(keep) && keep.matches && keep.matches('input')) { kn = keep.name; kv = keep.value; }
      var st = dr.scrollTop;
      $('.dnc-fd-body', dr).innerHTML = $('.dnc-fd-body', ndr).innerHTML;
      $('.dnc-fd-foot', dr).innerHTML = $('.dnc-fd-foot', ndr).innerHTML;
      dr.scrollTop = st;
      if (kn) {
        var back = $$('input', dr).filter(function (i) { return i.name === kn && i.value === kv; })[0];
        if (back) back.focus({ preventScroll: true });
      }
    }
  }
  function load(qs, opts) {
    opts = opts || {};
    var mine = ++seq;
    root.classList.add('is-loading');
    return fetchSection(qs).then(function (nr) {
      if (mine !== seq) return;
      swapIn(nr);
      var url = window.location.pathname + (qs ? '?' + qs : '');
      if (!opts.noHistory) window.history.pushState({ dnc: 1 }, '', url);
      if (opts.scroll) scrollToGrid();
    }).catch(function (err) {
      if (window.console) console.warn('[dn-coll] falling back to a full page load', err);
      window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    }).then(function () { if (mine === seq) root.classList.remove('is-loading'); });
  }
  window.addEventListener('popstate', function () {
    closeSort(); closePanel(false);
    load(window.location.search.replace(/^\?/, ''), { noHistory: true });
  });

  /* ---------- Load more ---------- */
  function loadMore(link) {
    var more = link.closest('[data-dnc-more]');
    var u = new URL(link.href, window.location.origin);
    var qs = carryView(new URLSearchParams(u.search)).toString();
    if (more) more.classList.add('is-busy');
    var mine = ++seq;
    fetchSection(qs).then(function (nr) {
      if (mine !== seq) return;
      var grid = $('[data-dnc-grid]', root), ngrid = $('[data-dnc-grid]', nr);
      var fresh = $$('.dnc-card', ngrid);
      fresh.forEach(function (c, i) {
        if (!reduce) {
          c.classList.add('dnc-fade');
          c.style.animationDelay = (Math.min(i, 8) * 40) + 'ms';
          c.addEventListener('animationend', function () { c.classList.remove('dnc-fade'); c.style.animationDelay = ''; }, { once: true });
        }
        grid.appendChild(c);
      });
      var nmore = $('[data-dnc-more]', nr);
      if (more) { if (nmore) more.replaceWith(nmore); else more.remove(); }
      var first = fresh[0] && $('h3 a', fresh[0]);
      if (first) first.focus({ preventScroll: true });
    }).catch(function (err) {
      if (window.console) console.warn('[dn-coll] load more failed, opening the next page', err);
      window.location.href = link.href;
    }).then(function () { if (more) more.classList.remove('is-busy'); });
  }

  /* ---------- dropdown panels on the desktop row: nothing changes until Apply ---------- */
  function syncPanel(fp) {
    $$('input', fp).forEach(function (i) {
      if (i.type === 'checkbox') i.checked = i.defaultChecked; else i.value = i.defaultValue;
    });
  }
  function openPanel(fp) {
    closeSort();
    if (pop && pop !== fp) closePanel(false);
    pop = fp;
    syncPanel(fp);
    fp.classList.add('is-open');
    $('[data-dnc-fpb]', fp).setAttribute('aria-expanded', 'true');
  }
  function closePanel(restore) {
    if (!pop) return;
    var fp = pop, b = $('[data-dnc-fpb]', fp);
    pop = null;
    fp.classList.remove('is-open');
    b.setAttribute('aria-expanded', 'false');
    syncPanel(fp);
    if (restore) b.focus({ preventScroll: true });
  }
  function applyPanel() {
    var qs = queryFrom($('.dnc-pills', root));
    /* the open panel's own boxes are what was just chosen; the others still hold the applied state */
    closeFocusless();
    load(qs, { scroll: true });
  }
  function closeFocusless() {
    if (!pop) return;
    pop.classList.remove('is-open');
    $('[data-dnc-fpb]', pop).setAttribute('aria-expanded', 'false');
    pop = null;
  }
  function clearPanel(fp) {
    $$('input', fp).forEach(function (i) { if (i.type === 'checkbox') i.checked = false; else i.value = ''; });
    applyPanel();
  }

  /* ---------- sort menu ---------- */
  function sortBtn() { return $('[data-dnc-sortbtn]', root); }
  function sortPop() { return $('[data-dnc-sortpop]', root); }
  function closeSort() {
    var sp = sortPop(), sb = sortBtn();
    if (sp) sp.classList.remove('is-open');
    if (sb) sb.setAttribute('aria-expanded', 'false');
  }
  function toggleSort() {
    var sp = sortPop(), sb = sortBtn();
    var o = sp.classList.toggle('is-open');
    sb.setAttribute('aria-expanded', o ? 'true' : 'false');
  }

  /* ---------- the phone filter sheet ---------- */
  function openDrawer(btn) {
    if (!drawer) return;
    closeSort(); closePanel(false);
    opener = btn || null;
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) body.style.paddingRight = sbw + 'px';
    body.classList.add('dnc-filters-open');
    var x = $('.dnc-x', drawer);
    setTimeout(function () { if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function closeDrawer() {
    if (!body.classList.contains('dnc-filters-open')) return;
    body.classList.remove('dnc-filters-open');
    body.style.paddingRight = '';
    if (opener) { opener.focus({ preventScroll: true }); opener = null; }
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!root.contains(t)) return;
    var o = t.closest('[data-dnc-drawer-open]');
    if (o) { openDrawer(o); return; }
    var cl = t.closest('[data-dnc-drawer-close]');
    if (cl) { closeDrawer(); return; }
    var fb = t.closest('[data-dnc-fpb]');
    if (fb) {
      var fp = fb.closest('[data-dnc-fp]');
      if (fp === pop) closePanel(true); else openPanel(fp);
      return;
    }
    var ap = t.closest('[data-dnc-panel-apply]');
    if (ap) { applyPanel(); return; }
    var pc = t.closest('[data-dnc-panel-clear]');
    if (pc) { clearPanel(pc.closest('[data-dnc-fp]')); return; }
    if (pop && !t.closest('[data-dnc-fp]')) closePanel(false);
    if (t.closest('[data-dnc-sortbtn]')) { toggleSort(); return; }
    var so = t.closest('[data-dnc-sortpop] [data-sort]');
    if (so) {
      e.preventDefault();
      var p = filtersOnly(window.location.search);
      var v = so.getAttribute('data-sort');
      if (v === root.getAttribute('data-default-sort')) p.delete('sort_by'); else p.set('sort_by', v);
      closeSort();
      load(p.toString(), { scroll: true });
      return;
    }
    if (!t.closest('.dnc-sortwrap')) closeSort();
    var chip = t.closest('[data-dnc-chip]');
    if (chip) {
      e.preventDefault();
      var u = new URL(chip.href, window.location.origin);
      var q = filtersOnly(u.search).toString();
      load(q, { scroll: !chip.hasAttribute('data-dnc-keep-open') && !body.classList.contains('dnc-filters-open') });
      return;
    }
    var lm = t.closest('[data-dnc-loadmore]');
    if (lm) { e.preventDefault(); loadMore(lm); return; }
  });

  /* the sheet applies at once; the panels wait for Apply */
  document.addEventListener('change', function (e) {
    if (!drawer || !drawer.contains(e.target)) return;
    if (!e.target.matches('input[data-dnc-in], input[data-dnc-price]')) return;
    load(queryFrom(drawer), {});
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.dnc-fpp [data-dnc-price]')) {
      e.preventDefault(); applyPanel(); return;
    }
    if (e.key === 'Tab' && drawer && body.classList.contains('dnc-filters-open')) {
      var f = $$('button, a[href], input', drawer).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
      if (f.length) {
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === drawer)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (e.key !== 'Escape') return;
    if (pop) { closePanel(true); return; }
    closeSort(); closeDrawer();
  });
  /* tabbing out of an open panel closes it; a click on a label hands focus to the page's own tabindex=-1 wrapper, which must not count */
  if (barEl) {
    barEl.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (pop && to && to.tabIndex >= 0 && !pop.contains(to)) closePanel(false);
    });
  }
  if (window.matchMedia) {
    var mq = window.matchMedia('(min-width:901px)');
    var onMq = function (q) { closePanel(false); if (q.matches) closeDrawer(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }
})();

/* dn-guard: this file ran to the end (guards spec G1) */
(window.__dnLoaded = window.__dnLoaded || {}).coll = true;
